<div class="container-fluid padMob" style="padding-left: 15px; padding-right: 15px;" id="excel-table">
    <div class="row ">
        <div class="col-md-12 col-12 col-sm-12 pad0 padHeder" style="padding-bottom: 0px; padding-top: 15px;">
            <div class="col-md-3 col-6 col-sm-6 inLneBlk" style="display: inline-block; padding-right: 0;">
                <!-- <span class="mobView" style="font-size: 22px; margin-right: 10px;" (click)="backBtn()"><i
                        class="fa fa-chevron-left"></i></span> -->
                <h2 class="lblHeader newHeader"> Trial Balance</h2>
            </div>

            <div class="col-md-9 col-6 col-sm-6" style="text-align: right; display: inline-block; padding-left: 0;">
                <div style="display: flex; justify-content: flex-end; align-items: center; column-gap: 8px;">
                    <div class="webView">
                        <div style="display: flex; justify-content: flex-end; align-items: center; column-gap: 8px;">                         
                            <select class="form-control formCtlFltr font13 bgwhite"
                                [(ngModel)]="selectedFY" (ngModelChange)="ddlchangeYear()"
                                style="padding: 1px 3px; font-size: 14px; position: relative; cursor: pointer; width: 115px;"
                                [style.width]="selectedFY == 'Other' ? '90px' : '115px'">
                                <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                                <option value="Other">Other</option>
                            </select>
                            <div *ngIf="selectedFY == 'Other'" style="display: flex; flex-wrap: wrap; align-items: center; column-gap: 10px;">
                                <div style="outline: none !important; display: inline-block;">
                                    <input matInput readonly disabled="{{disable.fromInput}}" (focus)="picker.open()" [matDatepicker]="picker"
                                        class="form-control formCtlFltr bgwhite" tabindex="1" [(ngModel)]="param.fromDT"
                                        style="display: inline-block; width: 90px; outline: none !important; cursor: pointer; background: #FFF;">
                                    <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                                </div>
                                <div style="display: inline-block; font-size: 13px;">to</div>
                                <div style="outline: none !important; display: inline-block;">
                                    <input matInput readonly disabled="{{disable.toInput}}" (focus)="picker2.open()" [matDatepicker]="picker2"
                                        class="form-control formCtlFltr bgwhite" tabindex="1" [(ngModel)]="param.toDT"
                                        style="display: inline-block; width: 90px; outline: none !important; cursor: pointer; background: #FFF;">
                                    <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                                </div>
                                <div>
                                    <span *ngIf="show.edit" class="orangeButton" style="width: auto; height: 30px; font-size: 13px !important;" [(ngModel)]="show.edit" (click)="editPeriod()">
                                        <i class="zmdi zmdi-edit" style="margin-right: 5px;"></i>
                                        <span> Edit </span>
                                    </span>
                                    <span *ngIf="show.save" class="darkBlueButton" style="width: auto; height: 30px; font-size: 13px !important;" [(ngModel)]="show.save" (click)="changePeriod()">
                                        <i class="zmdi zmdi-arrow-right" style="margin-right: 5px;"></i>
                                        <span> Fetch </span>
                                    </span>
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div>
                        <span class="orangeButton fntSz brdrRadius3" *ngIf="(finalArray.length > 0) && (isAdmin == true || usersAllAcctRights == true)" (click)="exportToExcelActivities()" title="Export to Excel" style="cursor:pointer;">
                            <span><i class="fa fa-file-excel-o" aria-hidden="true"></i></span>
                        </span>
                        <span class="darkBlueButton" style="font-size: 13px; margin-left: 8px; display: inline-block;" (click)="backBtn()">
                            <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 mobView">
                <div style="display: flex; flex-wrap: wrap; align-items: center; column-gap: 8px;">
                    <select class="form-control formCtlFltr font13 bgwhite"
                        [(ngModel)]="selectedFY" (ngModelChange)="ddlchangeYear()"
                        style="padding: 1px 3px; font-size: 14px; position: relative; cursor: pointer; margin-top: 10px;"
                        [style.width]="selectedFY == 'Other' ? '90px' : '115px'">
                        <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                        <option value="Other">Other</option>
                    </select>
                    <div *ngIf="selectedFY == 'Other'" style="display: flex; align-items: center; margin-top: 10px; column-gap: 10px;">
                        <div style="outline: none !important; display: inline-block;">
                            <input matInput readonly disabled="{{disable.fromInput}}" (focus)="picker.open()" [matDatepicker]="picker"
                                class="form-control formCtlFltr bgwhite" tabindex="1" [(ngModel)]="param.fromDT"
                                style="display: inline-block; width: 90px; outline: none !important; cursor: pointer; background: #FFF;">
                            <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                        </div>
                        <div style="display: inline-block; font-size: 14px;">to</div>
                        <div style="outline: none !important; display: inline-block;">
                            <input matInput readonly disabled="{{disable.toInput}}" (focus)="picker2.open()" [matDatepicker]="picker2"
                                class="form-control formCtlFltr bgwhite" tabindex="1" [(ngModel)]="param.toDT"
                                style="display: inline-block; width: 90px; outline: none !important; cursor: pointer; background: #FFF;">
                            <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                        </div>
                        <div>
                            <span *ngIf="show.edit" class="orangeButton" style="width: auto; height: 30px; font-size: 13px !important;" [(ngModel)]="show.edit" (click)="editPeriod()">
                                <i class="zmdi zmdi-edit" style="margin-right: 5px;"></i>
                                <span> Edit </span>
                            </span>
                            <span *ngIf="show.save" class="darkBlueButton" style="width: auto; height: 30px; font-size: 13px !important;" [(ngModel)]="show.save" (click)="changePeriod()">
                                <i class="zmdi zmdi-arrow-right" style="margin-right: 5px;"></i>
                                <span> Fetch </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-12 col-sm-12 pad0 " style="padding:15px;" *ngIf="finalArray.length > 0">
            <table class="table table-borderd ngTable bzMatTbl shadow" data-show-filter="true" id="productListTbl"
                style="margin-bottom: 10px; background-color: white; border-radius: 3px;">
                <thead>
                    <tr>
                        <th>Head / Ledger</th>
                        <th style="width: 150px; text-align: right; padding-right: 15px;">Opening</th>
                        <th style="width: 150px; text-align: right; padding-right: 15px;">Debit</th>
                        <th style="width: 150px; text-align: right; padding-right: 15px;">Credit</th>
                        <th style="width: 150px; text-align: right; padding-right: 15px;">Closing</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let Heads of finalArray" class="{{Heads.level == 0 ? 'backGroundCOlor' : ''}}"
                        style="cursor: pointer;"
                        (click)="expandView(Heads)">
                        <td class="{{Heads.level == 0 ? 'fontBold orangeText' : ''}}  {{Heads.level != 0 && Heads.ledgerID == 0  ? 'fontBold' : ''}}"
                        style="padding-left: {{Heads.level == 0 ? '5' : Heads.level * 20}}px;">
                            {{Heads.HeadName}}
                        </td>
                        <td class="{{Heads.level == 0 ? 'fontBold' : ''}}" style="text-align: right; width: 150px;">{{Heads.OpBal
                            |cRDB}}</td>
                        <td class="{{Heads.level == 0 ? 'fontBold' : ''}}" style="text-align: right; width: 150px;">{{Heads.DbAmt
                            |lacFormat}}</td>
                        <td class="{{Heads.level == 0 ? 'fontBold' : ''}}" style="text-align: right; width: 150px;">{{Heads.CrAmt
                            |lacFormat}}</td>
                        <td class="{{Heads.level == 0 ? 'fontBold' : ''}}" style="text-align: right; width: 150px; padding-right: 15px;">{{Heads.CloBal
                            |cRDB}}</td>
                    </tr>
                    <tr class="backGroundCOlor">
                        <td class="fontBold orangeText" style="padding-left: 5px;">Grand Total</td>
                        <td class="fontBold" style="text-align: right;">{{GrandTotal.opngTotal |cRDB}}</td>
                        <td class="fontBold" style="text-align: right;">{{GrandTotal.dbAmtTotal |lacFormat}}</td>
                        <td class="fontBold" style="text-align: right;">{{GrandTotal.crAmtTotal |lacFormat}}</td>
                        <td class="fontBold" style="text-align: right; padding-right: 15px;">{{GrandTotal.cloTotal |cRDB}}</td>
                    </tr>
                </tbody>
            </table>

        </div>


        <div class="col-md-12 col-12 col-sm-12 pad0 " style="padding:15px; display: none;" *ngIf="finalArray.length > 0">
            <table class="table table-borderd ngTable bzMatTbl shadow" data-show-filter="true" id="productListTbl"
                style="margin-bottom: 10px; background-color: white;">
                <thead>
                    <tr>
                        <th>Head / Ledger</th>
                        <th style="width: 150px;">Opening</th>
                        <th style="width: 150px;">Debit</th>
                        <th style="width: 150px;">Credit</th>
                        <th style="width: 150px;">Closing</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let Heads of finalArray" class="{{Heads.level == 0 ? 'backGroundCOlor' : ''}}"
                        style="cursor: pointer;"
                        (click)="expandView(Heads)">
                        <td class="{{Heads.level == 0 ? 'fontBold orangeText' : ''}}  {{Heads.level != 0 && Heads.ledgerID == 0  ? 'fontBold' : ''}}"
                        style="padding-left: {{Heads.level == 0 ? '5' : Heads.level * 20}}px;">
                            {{Heads.HeadName}}
                        </td>
                        <td class="{{Heads.level == 0 ? 'fontBold' : ''}}" style="text-align: right;">{{Heads.OpBal
                            |cRDB}}</td>
                        <td class="{{Heads.level == 0 ? 'fontBold' : ''}}" style="text-align: right;">{{Heads.DbAmt
                            |lacFormat}}</td>
                        <td class="{{Heads.level == 0 ? 'fontBold' : ''}}" style="text-align: right;">{{Heads.CrAmt
                            |lacFormat}}</td>
                        <td class="{{Heads.level == 0 ? 'fontBold' : ''}}" style="text-align: right;">{{Heads.CloBal
                            |cRDB}}</td>
                    </tr>
                    <tr class="backGroundCOlor">
                        <td class="fontBold orangeText" style="padding-left: 5px;">Grand Total</td>
                        <td class="fontBold" style="text-align: right;">{{GrandTotal.opngTotal |cRDB}}</td>
                        <td class="fontBold" style="text-align: right;">{{GrandTotal.dbAmtTotal |lacFormat}}</td>
                        <td class="fontBold" style="text-align: right;">{{GrandTotal.crAmtTotal |lacFormat}}</td>
                        <td class="fontBold" style="text-align: right;">{{GrandTotal.cloTotal |cRDB}}</td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>